<template>
  <v-snackbar
    v-model="visible"
    :timeout="timeout"
    :location="location"
    :color="color"
  >
    {{ message }}
    <template #actions>
      <v-btn variant="text" @click="close()">Cerrar</v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: "SnackBarGlobal",
  props: {
    modelValue: { type: Boolean, default: false },
    message: { type: String, default: "" },
    color: { type: String, default: "red" },
    timeout: { type: Number, default: 4500 },
    location: { type: String, default: "top" },
  },
  emits: ["update:modelValue"],
  computed: {
    visible: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },
  methods: {
    close() {
      this.visible = false;
    },
  },
};
</script>
